const mapAccompaniedToShipStatus = (accompanied) => {
  if (accompanied === true || accompanied === 'Accompanied' || accompanied === '1' || accompanied === 1) {
    return 'Accompanied';
  }
  if (accompanied === false || accompanied === 'Unaccompanied' || accompanied === '0' || accompanied === 0) {
    return 'Unaccompanied';
  }
  return accompanied;
};

export const normaliseUnifiedHeader = (header = {}) => {
  const { accompanied, ...headerWithoutAccompanied } = header;

  return {
    ...headerWithoutAccompanied,
    EntryPort1id: header.EntryPort1id ?? header.entryPort1,
    ExitPort1id: header.ExitPort1id ?? header.exitPort1,
    movementTypeId: header.movementTypeId ?? header.movementType,
    CountryofDesptachid: header.CountryofDesptachid ?? header.Countrydespatch ?? header.despatchCountry,
    CountryofDestinationid: header.CountryofDestinationid ?? header.Countrydestination ?? header.destinationCountry,
    trucktext: header.trucktext ?? header.vehicle,
    parentId: header.parentId ?? header.traderParent,
    parentName: header.parentName,
    parentEori: header.parentEori,
    shipStatus: header.shipStatus ?? mapAccompaniedToShipStatus(accompanied),
  };
};

const normaliseUnifiedItems = (items) => {
  if (!Array.isArray(items)) return items;

  return items.map((item) => ({
    ...item,
    Consignorid: item.Consignorid ?? item.neeNoridConsignor,
  }));
};

/**
 * Normalises CABIE and UNIFIED downloadable JSON into the shape expected by unified load import.
 */
export const normaliseLoadJsonResponse = (data) => {
  if (!data?.Headers) return data;

  if (Array.isArray(data.Headers)) {
    return {
      ...data,
      Headers: data.Headers.map(normaliseUnifiedHeader),
      Items: normaliseUnifiedItems(data.Items),
    };
  }

  return {
    ...data,
    Headers: [normaliseUnifiedHeader(data.Headers)],
    Items: normaliseUnifiedItems(data.Items),
  };
};
